import { observable } from "mobx";
import AccountBalanceCheckRequestCreationActionRejectionReason from "./accountBalanceCheckRequestCreationActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckRequestCreationActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  latestAccountingPeriodTo?: string;

  @observable
  rejectionReason?: AccountBalanceCheckRequestCreationActionRejectionReason;
}
